import { ReactNode } from 'react';
import { Trans } from 'react-i18next';
import { MARKET } from '@/common/constants/markets';
import {
  TInsuranceCoverage,
  TInsurancePerson,
} from '@/common/integrations/menhir/employee/insurance/insurance.types';
import { InsuranceUpgradePlanCardCostTable } from '@/web/containers/Insurance/InsuranceUpgrade/InsuranceUpgradePlanPage/components/InsurancePlanChooseStep/components/InsuranceUpgradePlanCard/components/InsuranceUpgradePlanCardCostTable/InsuranceUpgradePlanCardCostTable';
import { InsuranceUpgradePlanCardCoveragesTable } from '@/web/containers/Insurance/InsuranceUpgrade/InsuranceUpgradePlanPage/components/InsurancePlanChooseStep/components/InsuranceUpgradePlanCard/components/InsuranceUpgradePlanCardCoveragesTable/InsuranceUpgradePlanCardCoveragesTable';
import { InsuranceUpgradePlanCardHead } from '@/web/containers/Insurance/InsuranceUpgrade/InsuranceUpgradePlanPage/components/InsurancePlanChooseStep/components/InsuranceUpgradePlanCard/components/InsuranceUpgradePlanCardHead/InsuranceUpgradePlanCardHead';
import { useMarket } from '@/web/hooks/useMarket';
import { Button, Card, TextAction } from '@coverflex-tech/hypernova';
import { IFile } from '@coverflex-tech/hypernova-utils';
import cx from 'classnames';
import css from './InsuranceUpgradePlanCard.module.css';

export const InsuranceUpgradePlanCard = ({
  name,
  showBasePlanBadge,
  className,
  persons,
  coverages,
  hidePeopleList,
  onTogglePerson,
  onSelect,
  reservedComparableRowCount,
  reservedNonComparableRowCount,
  files,
}: TInsuranceUpgradePlanCardProps) => {
  const { slug } = useMarket();

  return (
    <Card className={cx(css.root, className)} plain>
      <InsuranceUpgradePlanCardHead
        title={name}
        showBadge={showBasePlanBadge}
      />
      <InsuranceUpgradePlanCardCostTable
        persons={persons}
        onTogglePerson={onTogglePerson}
        hidePersonsList={hidePeopleList}
      />
      <InsuranceUpgradePlanCardCoveragesTable
        coverages={coverages}
        reservedComparableRowCount={reservedComparableRowCount}
        reservedNonComparableRowCount={reservedNonComparableRowCount}
      />
      <div className={css.bottomWrapper}>
        <Button onClick={() => onSelect?.()} variant="secondary">
          <Trans i18nKey="dashboard.insurance.upgrade_plan.card.cta_label" />
        </Button>
      </div>
      {slug === MARKET.ES &&
        files?.find((f) => f.slug === 'general_conditions')?.url && (
          <TextAction
            as="a"
            href={files?.find((f) => f.slug === 'general_conditions')?.url}
            target="_blank"
            rel="noreferrer"
          >
            <Trans i18nKey="dashboard.insurance.upgrade_plan.step.choose_plan.conditions_sentence.link" />
          </TextAction>
        )}
    </Card>
  );
};

export type TInsuranceUpgradePlanCardProps = {
  name?: ReactNode;
  showBasePlanBadge?: boolean;
  className?: string;
  persons?: TInsurancePerson[];
  coverages?: TInsuranceCoverage[];
  hidePeopleList?: boolean;
  reservedComparableRowCount?: number;
  reservedNonComparableRowCount?: number;
  onTogglePerson?: (person: TInsurancePerson, checked: boolean) => void;
  onSelect?: Function;
  files?: IFile<string>[];
};
